import React, { useEffect, useRef, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import { classNames as cn } from 'helpers'
import styles from './SearchInput.module.scss'
import { ReactComponent as SearchIcon } from 'components/UI/icons/curved-search.svg'

export default function SearchInput(props) {
  const { backFunctionByObj = true } = props

  const [query, setQuery] = useState(props.initialValue || '')
  const [list, setList] = useState([false, []])
  const [selectedItem, setSelectedItem] = useState(null)

  const componentRef = useRef()
  const debounceRef = useRef(null)

  const fetchData = (value) => {
    const apiConf = {
      method: 'get',
      link: props.link,
      crm: props.crm || false,
      params: {
        search: value,
        limit: 99,
      },
    }
    superAxiosRequest(apiConf).then((res) => {
      let data = res.data.result
      if (props.getApiList) {
        data = props.getApiList(res.data.result)
      }
      setList([true, data])
    })
  }

  const debounce = (func, delay) => {
    return (...args) => {
      clearTimeout(debounceRef.current)
      debounceRef.current = setTimeout(() => {
        func.apply(this, args)
      }, delay)
    }
  }

  const onChangeHandler = (value) => {
    setQuery(value)
    if (value.length >= 3) {
      debounce(fetchData, 2000)(value)
    } else {
      setList([false, []])
    }
  }

  const setFull = (item) => {
    const displayValue = props.sub_key
      ? props.new_key
        ? item[props.sub_key]?.[props.new_key]
        : item[props.sub_key]?.name
      : props.new_key
        ? item[props.new_key]
        : item.name

    setQuery(displayValue || '')
    setSelectedItem(item)
    backFunctionByObj
      ? props.backFunction([{ ...item }])
      : props.backFunction(item)
    setList([false, []])
  }

  const clickOutsideHandler = (e) => {
    if (!componentRef.current.contains(e.target)) setList([false, []])
  }

  useEffect(() => {
    document.body.addEventListener('click', clickOutsideHandler)

    return () => document.body.removeEventListener('click', clickOutsideHandler)
  }, [])

  return (
    <div className={styles.smartFilter} ref={componentRef}>
      <div
        className={cn({
          [styles.smartFilterField]: true,
          [styles.error]: props.error,
        })}
      >
        <SearchIcon className={styles.smartFilterIcon} />
        <input
          placeholder={props.placeholder}
          value={query}
          onChange={(e) => onChangeHandler(e.target.value)}
        />
      </div>
      {list[0] && (
        <div className={styles.smartFilterList}>
          {list[1].length > 0 ? (
            list[1].map((item, index) => (
              <p
                className={styles.smartFilterLine}
                key={index}
                onClick={() => setFull(item)}
              >
                {props.formatOption
                  ? props.formatOption(item)
                  : props.sub_key
                    ? props.new_key
                      ? item[props.sub_key]?.[props.new_key]
                      : item[props.sub_key]?.name
                    : props.new_key
                      ? item[props.new_key]
                      : item.name}
              </p>
            ))
          ) : (
            <p className={styles.smartFilterEmpty}>
              По вашему запросу ничего не найдено
            </p>
          )}
        </div>
      )}
    </div>
  )
}
